/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import ApiKeyConstants from 'constants/ApiKeyConstants'
import ApiKeyQueries from 'queries/ApiKeyQueries'

const ApiKeyStore = Marty.createStore({
  id: 'ApiKeyStore',

  getInitialState() { return {
    apiKey: {}
  } },

  handlers: {
    getApiKeyDone: ApiKeyConstants.GET_API_KEY_DONE,
    createApiKeyDone: ApiKeyConstants.CREATE_API_KEY_DONE
  },

  getApiKeyDone(apiKey) {
    if (!this.setApiKey(apiKey)) {
      const orgId = this.app.stores.OrgStore.getCurrentOrg().id
      return this.createApiKey(orgId)
    }
  },

  getApiKeyForCurrentOrg() {
    return this.fetch({
      id: 'getApiKey',
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally() {
        if (this.hasAlreadyFetched('getApiKey')) {
          return this.state.apiKey
        }
      },
      remotely() {
        const orgId = this.app.stores.OrgStore.getCurrentOrg().id
        return this.app.queries.ApiKeyQueries.getApiKeyByOrgId(orgId)
      }
    })
  },

  createApiKey(orgId) {
    return this.app.queries.ApiKeyQueries.createApiKeyForOrgId(orgId)
  },

  createApiKeyDone(apiKey) {
    return this.setApiKey(apiKey)
  },

  setApiKey(apiKey) {
    if (!_.isEmpty(apiKey)) {
      this.setState({ apiKey: apiKey[0] })
      return true
    } else {
      return false
    }
  }
})

export default ApiKeyStore



// WEBPACK FOOTER //
// ./src/scripts/stores/ApiKeyStore.js